import { KeycloakProfile } from 'keycloak-js';

export interface KeycloakProfileWithAttributes extends KeycloakProfile {
  attributes?: { nickName?: string[] };
}

export enum UserRoles {
  TEACHER = 'TEACHER',
  STUDENT = 'STUDENT',
  ROLE_REVIEWER = 'ROLE_REVIEWER',
  REVIEWER = 'REVIEWER',
  READ_ONLY = 'READ_ONLY',
}
